import { Component, ViewChild, ElementRef } from '@angular/core';

import { ConferenceData } from '../../../providers/conference-data';
import { MissionsData } from '../../../providers/missions-data';

import {
    AlertController, Events, LoadingController, ModalController, NavController, Platform,
    ToastController
} from 'ionic-angular';
import {MissionsListPage} from "../missions-list/missions-list";
import {MapPage} from "../../map/map";
import {AngularFireDatabase} from "angularfire2/database";
import {UserData} from "../../../providers/user-data";

import {LocationSelectForm} from "../../utils/location-select/location-select";

import {MissionsFilterPage} from "../missions-filter/missions-filter";
import {MissionDetailPage} from "../mission-detail/mission-detail";
import {Geolocation} from "@ionic-native/geolocation";

declare var google: any;
declare var window: any;
//declare var handleMissionClick: any;

import * as MarkerClusterer from 'node-js-marker-clusterer';


@Component({
    selector: 'page-missions-map',
    templateUrl: 'missions-map.html'
})
export class MissionsMapPage {

    userInfos: any;
    userRef: any;
    sessionRef: any;

    locationSelectModal: any;
    locationSelectModalInited: boolean = false;
    queryText = '';
    segment = 'map';
    excludeTracks: any = [];
    shownSessions: any = [];
    groups: any = [];
    confDate: string;
    searchFilters: any;
    boundaries: any = false;
    locationAsked:boolean=false;
    missions:any;
    map:any;
    markers: any = [];
    markerCluster: any;
    location_marker: any = false;
    infoWindow: any;
    iconBase: string = 'assets/img/markers/';
    cluster_listener: any = false;
    icons: any = {
        'industrie': {
            icon: this.iconBase + 'pin-agriculture.png',//'PICTOS_METIERS_industrie-resized.png'
        },
        'agriculture-et-peche': {
            icon: this.iconBase + 'pin-agriculture.png',//'PICTOS_METIERS_agriculture-resized.png'
        },
        'banque': {
            icon: this.iconBase + 'pin-banque.png',//'PICTOS_METIERS_banque-resized.png'
        },
        'arts-et-faconnage-d-ouvrages-d-art': {
            icon: this.iconBase + 'pin-art.png',//'PICTOS_METIERS_art-resized.png'
        },
        'commerce': {
            icon: this.iconBase + 'pin-commerce.png',//'PICTOS_METIERS_commerce-resized.png'
        },
        'communication': {
            icon: this.iconBase + 'pin-communication.png',//'PICTOS_METIERS_communication-resized.png'
        },
        'construction': {
            icon: this.iconBase + 'pin-construction.png',//'PICTOS_METIERS_construction-resized.png'
        },
        'hotellerie-restauration-tourisme-loisirs-et-animation': {
            icon: this.iconBase + 'pin-hotellerie.png',//'PICTOS_METIERS_hotellerie-resized.png'
        },
        'installation-et-maintenance': {
            icon: this.iconBase + 'pin-install-maintenance.png',//'PICTOS_METIERS_install-maintenance-resized.png'
        },
        'sante': {
            icon: this.iconBase + 'pin-sante.png',//'PICTOS_METIERS_sante-resized.png'
        },
        'services-a-la-personne-et-a-la-collectivite': {
            icon: this.iconBase + 'pin-service-personne.png',//'PICTOS_METIERS_service-personne-resized.png'
        },
        'spectacle': {
            icon: this.iconBase + 'pin-spectacle.png',//'PICTOS_METIERS_spectacle-resized.png'
        },
        'support-a-l-entreprise': {
            icon: this.iconBase + 'pin-support.png',//'PICTOS_METIERS_support-entreprise-resized.png'
        },
        'transport': {
            icon: this.iconBase + 'pin-transport.png',//'PICTOS_METIERS_transport-resized.png'
        },
        'inconnu': {
            icon: this.iconBase + 'pin-inconnu.png',//'PICTOS_METIERS_transport-resized.png'
        },
        blue: {
            icon: this.iconBase + 'marker_azure-resized.png'
        },
        green: {
            icon: this.iconBase + 'marker_green-resized.png'
        },
        pink: {
            icon: this.iconBase + 'marker_pink-resized.png'
        },
        location: {
            icon: new google.maps.MarkerImage(this.iconBase + 'position.png',
                new google.maps.Size(22,22),
                new google.maps.Point(0,18),
                new google.maps.Point(11,11))
        }
    };
    loading: any = false;
    inited: any = false;
    currently_loading: any = false;
    mapIsCentered:boolean = true;

    @ViewChild('mapCanvas') mapElement: ElementRef;

    constructor(
        public alertCtrl: AlertController,
        public modalCtrl: ModalController,
        public navCtrl: NavController,
        public missionsData: MissionsData,
        public platform: Platform,
        public userData: UserData,
        public afDatabase: AngularFireDatabase,
        public loadingCtrl: LoadingController,
        private geolocation: Geolocation,
        public toastCtrl: ToastController,
        public events: Events

    ) {
        this.inited=false;
    }
    setLoading(state,msg=""){
        if(msg == "")msg = 'Chargement des missions ...';
        if(state && !this.currently_loading)
        {
            this.currently_loading = true;
            this.loading = this.loadingCtrl.create({
                content: msg
            });
            this.loading.present();
        }
        else if(this.loading && this.currently_loading){
            this.currently_loading = false;
            //this.loadingCtrl.dismiss();
            this.loading.dismiss();
        }
    }

    createMap(){

        // Snazy map : https://snazzymaps.com/style/70/unsaturated-browns

        let mapEle = this.mapElement.nativeElement;
        this.map = new google.maps.Map(mapEle, {
            disableDefaultUI: true,
            zoom: 13,
            maxZoom:18,
            //styles: [{"elementType":"labels","stylers":[{"visibility":"off"},{"color":"#f49f53"}]},{"featureType":"landscape","stylers":[{"color":"#f9ddc5"},{"lightness":-7}]},{"featureType":"road","stylers":[{"color":"#813033"},{"lightness":43}]},{"featureType":"poi.business","stylers":[{"color":"#645c20"},{"lightness":38}]},{"featureType":"water","stylers":[{"color":"#1994bf"},{"saturation":-69},{"gamma":0.99},{"lightness":43}]},{"featureType":"road.local","elementType":"geometry.fill","stylers":[{"color":"#f19f53"},{"weight":1.3},{"visibility":"on"},{"lightness":16}]},{"featureType":"poi.business"},{"featureType":"poi.park","stylers":[{"color":"#645c20"},{"lightness":39}]},{"featureType":"poi.school","stylers":[{"color":"#a95521"},{"lightness":35}]},{},{"featureType":"poi.medical","elementType":"geometry.fill","stylers":[{"color":"#813033"},{"lightness":38},{"visibility":"off"}]},{},{},{},{},{},{},{},{},{},{},{},{"elementType":"labels"},{"featureType":"poi.sports_complex","stylers":[{"color":"#9e5916"},{"lightness":32}]},{},{"featureType":"poi.government","stylers":[{"color":"#9e5916"},{"lightness":46}]},{"featureType":"transit.station","stylers":[{"visibility":"off"}]},{"featureType":"transit.line","stylers":[{"color":"#813033"},{"lightness":22}]},{"featureType":"transit","stylers":[{"lightness":38}]},{"featureType":"road.local","elementType":"geometry.stroke","stylers":[{"color":"#f19f53"},{"lightness":-10}]},{},{},{}]
            //styles: [{featureType: 'poi.business',stylers: [{visibility: 'off'}]},{featureType: 'transit',elementType: 'labels.icon',stylers: [{visibility: 'off'}]}]
            //styles:[{"elementType":"geometry","stylers":[{"hue":"#ff4400"},{"saturation":-68},{"lightness":-4},{"gamma":0.72}]},{"featureType":"road","elementType":"labels.icon"},{"featureType":"landscape.man_made","elementType":"geometry","stylers":[{"hue":"#0077ff"},{"gamma":3.1}]},{"featureType":"water","stylers":[{"hue":"#00ccff"},{"gamma":0.44},{"saturation":-33}]},{"featureType":"poi.park","stylers":[{"hue":"#44ff00"},{"saturation":-23}]},{"featureType":"water","elementType":"labels.text.fill","stylers":[{"hue":"#007fff"},{"gamma":0.77},{"saturation":65},{"lightness":99}]},{"featureType":"water","elementType":"labels.text.stroke","stylers":[{"gamma":0.11},{"weight":5.6},{"saturation":99},{"hue":"#0091ff"},{"lightness":-86}]},{"featureType":"transit.line","elementType":"geometry","stylers":[{"lightness":-48},{"hue":"#ff5e00"},{"gamma":1.2},{"saturation":-23}]},{"featureType":"transit","elementType":"labels.text.stroke","stylers":[{"saturation":-64},{"hue":"#ff9100"},{"lightness":16},{"gamma":0.47},{"weight":2.7}]}]
            styles:[{
                featureType: "poi",
                elementType: "labels",
                stylers: [{
                    visibility: "off"
                }]
            }]
        });
        var that = this;
        google.maps.event.addListenerOnce(this.map, 'idle', () => {
            if(that.searchFilters && this.searchFilters.location) {
                that.map.setCenter(new google.maps.LatLng(that.searchFilters.location.lat, that.searchFilters.location.lng));
                var bounds = this.map.getBounds();
                that.boundaries = bounds;
            }

            mapEle.classList.add('show-map');

            that.infoWindow = new google.maps.InfoWindow({
                content: `<h5>...</h5>`
            });

            that.setLoading(false);
            //that.updateSchedule();
            google.maps.event.addListener(that.map, 'idle', () => {
                that.mapIsCentered=false;
                that.updateSchedule();
            });
        });
        window.navCtrl = this.navCtrl;
        window.map = this.map;
        this.map.addListener('click_mission', function(missionId) {
            window.navCtrl.push(MissionDetailPage, { missionId: missionId });
        });
        this.map.addListener('bounds_changed', function() {
            var bounds = that.map.getBounds();
            that.boundaries=bounds;
        });

    }
    updateMapCenter(){
        if(!this.map)
            this.createMap();

        if(this.searchFilters && this.searchFilters.location && this.searchFilters.location.lat) {
            this.map.setCenter(new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng));
        }
        this.mapIsCentered=true;
    }
    recenterMap(){
        if(!this.map)
            this.createMap();

        if(this.searchFilters && this.searchFilters.location && this.searchFilters.location.lat) {
            this.map.setZoom(14);
            this.updateMapCenter();
        }

    }
    updateSchedule() {
        if(!this.map)
            this.createMap();
        var that = this;
        /*for(let i;i<this.markers.length;i++)
        {
            this.markers[i].setMap(null);
        }
        this.markers = [];*/
        this.searchFilters = this.userData.get('searchFilters');


        this.missionsData.getMap(this.searchFilters,this.boundaries).subscribe((mapData: any) => {
            this.missions=mapData;
            this.shownSessions = this.missionsData.listLength;
            if(mapData) {

                if(this.searchFilters.location.enabled)
                {
                    if(this.location_marker)
                    {
                        this.location_marker.setMap(null);
                        this.location_marker = new google.maps.Marker({
                            position: new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng),
                            map: this.map,
                            icon: this.icons['location'].icon,
                        });
                    }
                    else
                    {
                        let marker = new google.maps.Marker({
                            position: new google.maps.LatLng(this.searchFilters.location.lat, this.searchFilters.location.lng),
                            map: this.map,
                            icon: this.icons['location'].icon,
                        });
                        this.location_marker = marker;
                    }
                }
                var markers = [];
                //mapData.forEach((markerData: any) => {
                    //if(!markerData.hide)
                    //{
                for(let i in mapData)
                {
                    let markerData = mapData[i];
                    var key = markerData.id;
                        if(!this.markers[key]) {
                            let icon = false;
                            if(markerData['job_category'] && this.icons[markerData['job_category']])
                            {
                                icon = this.icons[markerData['job_category']].icon
                            }
                            else {
                                //console.log(markerData['job_category']);
                                icon = this.icons['inconnu'].icon
                            }

                            let marker = new google.maps.Marker({
                                position: new google.maps.LatLng(markerData.location_lat, markerData.location_lng),
                                map: that.map,
                                title: markerData.name,
                                city: markerData.location_city,
                                content: this.infoWindowTemplate(markerData),
                                multipleContent: this.infoWindowLineTemplate(markerData),
                                icon: icon,
                            });
                            this.markers[key] = marker;


                            this.markers[key].addListener('click', () => {

                                this.infoWindow.setContent(marker.content);
                                this.infoWindow.open(that.map, marker);
                            });
                        }
                        if(markerData.hide)
                        {
                            this.markers[key].setVisible(false);
                            //this.markers[key].setMap(null);
                        }
                        else {
                            this.markers[key].setVisible(true);
                            //this.markers[key].setMap(this.map);
                            markers.push(this.markers[key]);

                        }
                    //}


                };//);

                if(!this.markerCluster)
                    this.markerCluster = new MarkerClusterer(this.map, markers, {ignoreHidden:false, imagePath: 'assets/img/clusters/j','textColor':"#FFFFFF"});
                else {

                    this.markerCluster.clearMarkers();
                    this.markerCluster.addMarkers(markers);
                    this.markerCluster.repaint();
                }
                if( !this.cluster_listener) {
                    this.cluster_listener = google.maps.event.addListener(this.markerCluster, 'clusterclick', function (cluster) {
                        /*map.setCenter(cluster.getCenter());
                        map.setZoom(map.getZoom()+1);*/


                        /*map.setCenter(cluster.getCenter());
                        map.setZoom(map.getZoom()+1);*/
                        //console.log('oups',cluster);
                        /*let markerP = {
                            position: new google.maps.LatLng(markerData.location_lat, markerData.location_lng),
                            map: that.map,
                            title: markerData.name,
                            content: this.infoWindowTemplate(markerData),
                            multipleContent: this.infoWindowLineTemplate(markerData),
                            icon: icon,
                        };*/
                        var clustered = false;
                        for(var p=0;p<cluster.markerClusterer_.markers_.length;p++)
                        {
                            var marker = cluster.markerClusterer_.markers_[p];
                            /*console.log(
                                cluster.center_.lat() , marker.position.lat(),  cluster.center_.lng() , marker.position.lng()
                            );*/
                            clustered = (cluster.center_.lat() == marker.position.lat()) &&  (cluster.center_.lng() == marker.position.lng());
                        }
                        if(that.map.getZoom()==18 ) {
                            that.infoWindow.setContent(that.infoWindowMultipleTemplate(cluster.markerClusterer_.markers_));
                            that.infoWindow.setPosition(cluster.center_);
                            that.infoWindow.open(that.map/*, cluster.markerClusterer_.markers_[0]*/);
                        }
                        if(clustered ) {
                            setTimeout(function(){
                                that.infoWindow.setContent(that.infoWindowMultipleTemplate(cluster.markerClusterer_.markers_));
                                that.infoWindow.setPosition(cluster.center_);
                                that.infoWindow.open(that.map/*, cluster.markerClusterer_.markers_[0]*/);
                            },1000);

                        }

                    });
                }

                this.boundaries=this.map.getBounds();
            }
        });
        /*this.missionsData.getList(this.searchFilters,this.queryText).subscribe((mapData: any) => {
            this.missions=mapData;
        });*/
    }
    presentFilter() {

        let modal = this.modalCtrl.create(MissionsFilterPage, this.excludeTracks);
        modal.present();

        modal.onWillDismiss((data: any[]) => {
            if (data) {
                this.updateMapCenter();
                this.updateSchedule();
            }
        });

    }
    ionViewDidLoad() {
        if(!this.map)
            this.createMap();
        this.getUserInfos();

    }
    ionViewWillUnload(){
        this.userRef.unsubscribe();
        this.sessionRef.unsubscribe();
    }
    ionViewWillEnter(){

        //this.updateSchedule();

    }
    ionViewWillLeave(){

        //this.updateSchedule();

    }
    getUserInfos() {

        var that = this;
        that.sessionRef = that.userData.userSession().subscribe(session => {
            if (session != null) {
                that.userRef = that.userData.load().subscribe(user => {

                    var that = this;
                    if (!that.inited) {
                        that.inited = true;
                        that.setLoading(true);
                    }
                    //this.userData.checkLoggedIn(this.navCtrl,'MissionsListPage');
                    that.searchFilters = that.userData.get('searchFilters');

                    if (that.searchFilters.location && !that.searchFilters.location.enabled) {
                        that.setLoading(false);
                        that.launchLocate();
                    }
                    else {
                        that.setLoading(false);
                        that.updateMapCenter();
                        that.updateSchedule();
                    }

                });
            }
        });

    }
    launchLocate(){
        this.geoLocate();
    }
    askSearchFilters()
    {
        if(!this.locationAsked)
        {
            this.locationAsked = true;
            let prompt = this.alertCtrl.create({
                title: 'Emplacement de la recherche',
                message: "Pour vous proposer des missions nous devons savoir dans quelle région vous vous trouvez.",
                buttons: [
                    {
                        text: 'Me localiser',
                        handler: data => {
                            this.locationAsked = false;
                            this.geoLocate();
                        }
                    },
                    {
                        text: 'Chercher autour d\'une adresse',
                        handler: data => {
                            this.locationAsked = false;
                            this.chooseLocation();
                        }
                    }
                ]
            });
            prompt.present();
        }
    }
    geoLocate()
    {
        if(!this.locationAsked) {
            this.locationAsked = true;
            this.setLoading(true, 'Géolocalisation en cours ...');
            this.geolocation.getCurrentPosition().then((resp) => {
                this.searchFilters.location.lat = resp.coords.latitude;
                this.searchFilters.location.lng = resp.coords.longitude;
                this.searchFilters.location.enabled = true;
                this.searchFilters.location.mode = "position";
                var geocoder = new google.maps.Geocoder;
                var latlng = {lat: resp.coords.latitude, lng: resp.coords.longitude};
                var that = this;
                geocoder.geocode({'location': latlng}, function (results, status) {
                    if (status === 'OK') {
                        if (results[0]) {
                            that.searchFilters.location.address = results[0].formatted_address;
                        } else {
                        }
                        that.userData.set('searchFilters/location', that.searchFilters.location);
                    } else {
                    }
                    that.setLoading(false);
                    that.locationAsked = false;
                    that.updateMapCenter();
                    that.updateSchedule();
                });
            }).catch((error) => {
                const toast = this.toastCtrl.create({
                    message: 'La géolocalisation a échoué. ' +
                    'Il est possible que vous ayez refusé d\'être géolocalisé ou que les paramètres de votre appareil ne le permette pas.' +
                    'N\'hésitez pas à choisir le mode de recherche par adresse.',
                    showCloseButton: true,
                    cssClass: 'danger',
                    closeButtonText: 'Ok',
                    dismissOnPageChange: true,
                    duration: 10000
                });
                toast.present();
                //this.searchFilters.location.mode = 'address';
                this.setLoading(false);
                this.locationAsked = false;
                this.askSearchFilters();
            });
        }
    }
    chooseLocation()
    {

        var that = this;
        this.locationSelectModal = this.modalCtrl.create(LocationSelectForm, { mode: "address" });

            this.locationSelectModal.onDidDismiss(place => {
                let geometry = place.geometry;
                let locationData = {};
                if ((geometry) !== undefined) {
                    locationData = {
                        lng: geometry.location.lng(),
                        lat: geometry.location.lat(),
                        mode: "address",
                        address:place.formatted_address,
                        enabled: true,
                        distance:50
                    };
                    this.map.setCenter(new google.maps.LatLng(geometry.location.lat(), geometry.location.lng()));
                    this.userData.update('searchFilters','location',locationData);
                    //this.userData.getUserDbReference('searchFilters').update({'location':locationData});
                    //this.userData.getUserDbReference('searchFilters').update({'filter':'new'});
                    /*this.userData.getToken().then(function(token){
                        var userInfos  = that.afDatabase.object('/users/'+token+'/searchFilters/location').set(
                            locationData
                        );
                    });*/
                    this.updateSchedule();
                    this.updateMapCenter();
                }

            });

        this.locationSelectModal.present();
    }
    gotoMap() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsMapPage);
    }
    gotoList() {
        // go to the session detail page
        // and pass in the session data

        this.navCtrl.setRoot(MissionsListPage);
    }
    missionClick(mission)
    {

    }
    infoWindowTemplate(mission)
    {
        var label_styles = "width:30%; padding:5px;font-weight:bold;font-size:13px;";
        var value_styles = "width:30%; padding:5px;font-size:13px;text-align:right;";
        var line_styles = "border-bottom:1px solid #eee;padding:3px;";
        var width = "210px";
        var width2 = "195px";
        var contentString = '<br/><div id="content" style="max-width: '+width+' !important;width: '+width+' !important;margin-left: 5px;margin-bottom: 5px;">'+
            '<div id="siteNotice">'+
            '</div>'+
            '<h1 id="firstHeading" class="firstHeading" style="margin-top:0px !important;font-size:15px;max-width: '+width2+' !important;width: '+width2+' !important;">'+mission.name+'</h1>'+
            '<div id="bodyContent" style="max-width: '+width2+' !important;width: '+width2+' !important;">'+
            '<p>';

        if(mission.type!="free") {
            contentString += '<table style="font-size:15px;max-width: '+width2+' !important;width: '+width2+' !important;">'+
                ((mission.agency)?'<tr style="' + line_styles + '"><td style="' + label_styles + '">Agence</td><td style="' + value_styles + '">'+mission.agency.label+'</td> </tr>':'') +
            '<tr style="' + line_styles + '"><td style="' + label_styles + '">Début</td><td style="' + value_styles + '">dés que possible</td> </tr>' +
            '<tr style="' + line_styles + '"><td style="' + label_styles + '">Tx horaire</td><td style="' + value_styles + '">' + mission.hour_price + ' €/h' + '</td></tr>' +
            '<tr style="' + line_styles + '"><td style="' + label_styles + '">Salaire</td><td style="' + value_styles + '">'+ mission.net_hour_price_libelle +'</td></tr>' +
            ((mission.has_primes) ? '<tr style="' + line_styles + '"><td style="' + label_styles + '"></td><td style="' + value_styles + '">+ primes</td></tr>' : '') +
            '</table>';
        }
        else
        {
            contentString += '<table style="font-size:15px;max-width: '+width2+' !important;width: '+width2+' !important;">'+
                ((mission.agency)?'<tr style="' + line_styles + '"><td style="' + label_styles + '">Agence</td><td style="' + value_styles + '">'+mission.agency.label+'</td> </tr>':'') +
                '<tr style="' + line_styles + '"><td style="' + label_styles + '">Début</td><td style="' + value_styles + '">dés que possible</td> </tr>' +
                '<tr style="' + line_styles + '"><td style="' + label_styles + '">Salaire</td><td style="' + value_styles + '">'+ mission.net_hour_price_libelle +'</td></tr>' +
                '</table>';
        }
        contentString+='</p>'+
            '<a style="width:100%;text-align:center;display:block;padding:10px;color:white;background-color:#0081b0;font-size:14px;margin-top:10px;" data-id="'+mission.id+'" onclick="google.maps.event.trigger(window.map, \'click_mission\',\''+mission.id+'\')">En savoir plus</a>'+
            //'<p>Entreprise: Uluru, <a href="https://en.wikipedia.org/w/index.php?title=Uluru&oldid=297882194">'+
            //'https://en.wikipedia.org/w/index.php?title=Uluru</a> '+
            '</p>'+
            '</div>'+
            '</div>';
        return contentString;
    }
    infoWindowLineTemplate(mission)
    {
        var label_styles = "width:65%; display:block;padding:4px 1px;vertical-align:middle;float:left; font-size:12px;";
        var value_styles = "width:34%; display:block;padding:0px 11px;text-align:center;float:left;line-height:8px;";
        var line_styles = "cursor:pointer;border-bottom:1px solid #eee;padding:10px 0px; display:block;width:100%;float:left;clear:both;";
        var contentString =

            '<tr style="'+line_styles+'" '+'onclick="google.maps.event.trigger(window.map, \'click_mission\',\''+mission.id+'\')"'+' >' +
            '<td style="'+label_styles+'">'+mission.name+'</td>' +
            '<td style="'+value_styles+'">'+((mission.agency)?'<img src="'+mission.agency.logo+'" title="'+mission.agency.label+'" style="height:25px;margin-top:5px;"/>':'')+'<span style="font-size:7px;line-height:8px;"><br/>'+((mission.agency)?mission.agency.label:'Novaterim')+'</span></td>' +
            /*'<td style="'+value_styles+'">'+'<a style="width:48px;text-align:center;display:block;padding:5px 10px;color:white;background-color:#0081b0;font-size:14px;margin-top:10px;" data-id="'+mission.id+'" onclick="google.maps.event.trigger(window.map, \'click_mission\',\''+mission.id+'\')">Voir</a>' +'</td> ' +*/
            '</tr>'
            ;
        return contentString;
    }
    infoWindowMultipleTemplate(markers)
    {

        var label_styles = "width:30%; padding:5px;font-weight:bold;";
        var value_styles = "width:30%; padding:5px;";
        var line_styles = "border-bottom:1px solid #eee;padding:3px;";
        var width = "210px";
        var width2 = "195px";
        var sample_marker = markers[0];

        var contentString = '<br/><div id="content" style="max-width: '+width+' !important;width: '+width+' !important;margin-left: 5px;margin-bottom: 5px;">'+
            '<div id="siteNotice">'+
            '</div>'+
            '<h1 id="firstHeading" class="firstHeading" style="margin-top:0px !important;font-size:15px;max-width: '+width2+' !important;width: '+width2+' !important;">'+sample_marker.city+' : '+markers.length+' opportunité(s)</h1>'+
            '<div id="bodyContent" style="max-width: '+width2+' !important;width: '+width2+' !important;">'+

            '<table style="font-size:15px;max-width: '+width2+' !important;width: '+width2+' !important;">';
            for(var p=0;p<markers.length;p++)
            {
                var marker = markers[p];
                contentString+=marker.multipleContent;
            }
            contentString+='</table>'+
                "";//'<a style="width:100%;text-align:center;display:block;padding:10px;color:white;background-color:#0081b0;font-size:14px;margin-top:10px;" data-id="'+mission.id+'" onclick="google.maps.event.trigger(window.map, \'click_mission\','+mission.id+')">En savoir plus</a>'+
            //'<p>Entreprise: Uluru, <a href="https://en.wikipedia.org/w/index.php?title=Uluru&oldid=297882194">'+
            //'https://en.wikipedia.org/w/index.php?title=Uluru</a> '+

            '</div>'+
            '</div>';
        return contentString;


    }
}



// WEBPACK FOOTER //
// ./src/pages/missions/missions-map/missions-map.ts